<template>
  <v-card class="main-content-card" flat>
    <v-toolbar flat>
      <v-toolbar-title>用户</v-toolbar-title>
      <span class="subheading ml-2">|</span>
      <v-btn round small color="primary" class="white--text"
             :disabled="!funcIds.includes('c_syst_user')"
             @click.native.stop="() => { editDbid = null; edit = true; }">
        <v-icon dark small>add</v-icon>单个创建
      </v-btn>
    </v-toolbar>

    <!-- 检索功能区 -->
    <v-container fluid grid-list-md class="px-4" style="background-color: rgba(245, 245, 245, 0.6);">
      <v-layout row wrap>
        <v-flex d-flex xs10>
          <v-layout row wrap>
            <v-flex xs12 sm3>
              <v-text-field
                label="姓名"
                v-model="form.name"
                :clearable="true"
                hide-details
              />
            </v-flex>

            <v-flex xs12 sm3>
              <v-text-field
                label="用户名"
                v-model="form.username"
                :clearable="true"
                hide-details
              />
            </v-flex>

            <v-flex xs12 sm3>
              <v-select
                item-text="name"
                item-value="dbid"
                :items="roleItems"
                v-model="form.roleId"
                label="角色"
                hide-details
                clearable
              />
            </v-flex>

            <v-flex xs12 sm3>
              <v-select
                item-text="name"
                item-value="dbid"
                :items="deptItems"
                v-model="form.deptId"
                label="部门"
                hide-details
                clearable
              />
            </v-flex>

            <v-flex xs12>
              <span>状态：</span>
              <v-btn-toggle
                v-model="form.disabled"
                class="transparent"
                style="background:none;box-shadow:none"
              >
                <v-btn flat value=""><span>全部</span></v-btn>
                <v-btn flat value="T"><span>禁用</span></v-btn>
                <v-btn flat value="F"><span>启用</span></v-btn>
              </v-btn-toggle>
            </v-flex>

          </v-layout>
        </v-flex>
        <v-flex d-flex xs2 text-xs-center>
          <div>
            <v-btn color="primary" @click="onSearch">
              <v-icon dark>search</v-icon>
              检索
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-divider/>
    <v-data-table
      :headers="headers"
      :loading="loading"
      item-key="dbid"
      :pagination.sync="query"
      :items="pageResult.items"
      :total-items="pageResult.total"
      :rows-per-page-items="[10, 25, 50, 100, 200]"
    >
      <template slot="items" slot-scope="props">
        <td>
          {{ props.index + 1}}
        </td>
        <td>{{ props.item.username }}</td>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.number }}</td>
        <td>{{ props.item.deptRoles.map(dr => `${dr.department.name}（${dr.role.name}）`).join(", ") }}</td>
        <td>{{ props.item.disabled === true ? "是" : "否" }}</td>

        <td class="justify-center layout px-0">
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="() => { viewDbid = props.item.dbid; view = true; }">
              <v-icon color="teal">more_horiz</v-icon>
            </v-btn>
            <span>查看</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   :disabled="!funcIds.includes('u_syst_user')"
                   @click="() => { editDbid = props.item.dbid; edit = true; }">
              <v-icon color="teal">edit</v-icon>
            </v-btn>
            <span>编辑</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   :disabled="!funcIds.includes('d_syst_user')"
                   @click="() => { deleDbid = props.item.dbid; deleMsg = props.item.name; dele = true; }">
              <v-icon color="pink">delete</v-icon>
            </v-btn>
            <span>删除</span>
          </v-tooltip>
          <v-tooltip v-if="managerDisna" top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="() => { pUserId = props.item.dbid; pUserName = props.item.name; viewManager = true; }">
              <v-icon color="teal">category</v-icon>
            </v-btn>
            <span>主管</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>

    <x-view
      v-model="view"
      :dbid="viewDbid"
    />

    <x-edit
      v-model="edit"
      :dbid="editDbid"
      v-on:ok="onEditOk"
    />

    <x-delete
      v-model="dele"
      :message="deleMsg"
      :uri="uri"
      :dbid="deleDbid"
      v-on:ok="onDeleOk"
    />

    <x-proj-manager
      v-model="viewManager"
      :user-id = pUserId
      :user-name = pUserName
    />

  </v-card>
</template>

<script>
  import {mapGetters} from 'vuex'

  import XView from './View'
  import XEdit from './Edit'
  import XDelete from '../../global/Delete'
  import XProjManager from "@/components/syst/user/ProjManager";

  import mixin from '@/mixin'

  const baseUri = '/api/syst/user';
  const roleUri = '/api/syst/role';
  const deptUri = '/api/syst/department';

  export default {
    // 混入模块主页面（index）基本功能
    mixins: [mixin.index(baseUri)],

    components: {XView, XEdit, XDelete, XProjManager},

    data() {
      return {
        uri: baseUri,
        // 检索、分页、排序条件条件
        query: {
          name: '',
          username:'',
          roleId: '',
          deptId: '',
          disabled: '',

          page: 1,
          rowsPerPage: 25,
          sortBy: null,
          descending: null,
          totalItems: null
        },

        // 检索框
        form: {
          name: '',
          username:'',
          roleId: '',
          deptId: '',
          disabled: '',
        },

        // 表头
        headers: [
          {text: '#', align: 'left', sortable: false, value: 'dbid', width: "16"},
          {text: '用户名', align: 'left', sortable: true, value: 'username'},
          {text: '姓名', align: 'left', sortable: true, value: 'name'},
          {text: '工号/学号', align: 'left', sortable: true, value: 'number'},
          {text: '部门(角色)', align: 'left', sortable: true, value: 'departments'},
          {text: '禁用', align: 'left', sortable: true, value: 'disabled'},
          {text: '操作', align: 'center', sortable: false, value: 'dbid', width: "160"}
        ],

        roleItems: [],
        deptItems: [],

        view: false,
        viewDbid: null,

        viewManager: false,
        pUserId : '',
        pUserName: '',

        edit: false,
        editDbid: null,

        dele: false,
        deleDbid: null,
        deleMsg: null,

        managerDisna : false,
      }
    },

    computed: {
      ...mapGetters(['funcIds','roleName'])
    },

    created() {
      // 加载审核状态
      this.axios.all([
        this.axios.get(roleUri),
        this.axios.get(deptUri, {params: {limit: 512, disabled: 'F', sort: 'rank.asc'}}),
      ]).then(
        this.axios.spread(
          (rspRole, rspDept) => {
            this.roleItems = rspRole.data.items;
            this.deptItems = rspDept.data.items;
          }
        )
      )

      if (this.roleName === "系统管理员")
      {
        this.managerDisna = true
      }
      else
        this.managerDisna = false
    },

    methods: {
      // 检索响应函数
      onSearch() {
        window.console.log(this.roleName)
        Object.assign(this.query, this.form);
        this.query.page = 1;
        this.doRoute(this.query);
      },
    }
  }
</script>
